import { useMemo } from 'react';
import { CaldeiraIcon } from '@/components/icons/CaldeiraIcon';
import { User, FolderOpen } from 'lucide-react';
import { useNavigation } from '@/contexts/NavigationContext';
import { useProject } from '@/hooks/useProject';
import type { ScopeFilter } from '@/types/navigation';

export interface ScopeOption {
  id: ScopeFilter;
  label: string;
  icon?: React.ReactNode;
}

/**
 * Returns the list of scope filter options based on current navigation context.
 * Includes a project pill when inside a project.
 */
export function useScopeOptions(): ScopeOption[] {
  const { navigation } = useNavigation();
  const { data: project } = useProject(navigation.projectId);

  return useMemo(() => {
    const options: ScopeOption[] = [
      { id: 'all', label: 'Todos' },
      { id: 'global', label: 'Espaço Caldeira', icon: <CaldeiraIcon className="w-3 h-3" /> },
      { id: 'personal', label: 'Pessoal', icon: <User className="w-3 h-3" /> },
    ];

    if (navigation.projectId) {
      const projectLabel = project ? `${project.icon} ${project.name}` : 'Projeto';
      options.splice(1, 0, {
        id: `project:${navigation.projectId}`,
        label: projectLabel,
        icon: !project ? <FolderOpen className="w-3 h-3" /> : undefined,
      });
    }

    return options;
  }, [navigation.projectId, project]);
}
